export const notSchCon = {
    notify_sch: ['notify.sch.con'],
    mpPageReset: ['mp.pageReset'],
    mpAppReset: ['mp.appReset'],
    known_issues: ['notify.known.issues'],
    notify_sch_con: (pageFilter) => [...notSchCon.notify_sch, pageFilter],
};
